import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import CreditNotesView from "./CreditNotesView";
var dateFormat = require("dateformat");

class CreditNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CreditNotesShow: false,
      page: 0,
      perPage: 10,
      Spage: 0,
      perPageS: 10,
      searchCreditNote: "",
      searchShow: false,
    };
  }

  componentDidMount() {
    this.props.CreditNote();
  }

  handleCreditNotesView = (item) => {
    this.setState({
      CreditNotesShow: true,
      CreditNotesDtls: item,
    });
  };

  handleCloseCreditNotesView = () => {
    this.setState({ CreditNotesShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.CreditNotesSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });
    let Sdata = {
      Spage: selectedSearchPage + 1,
      CreditNote: this.state.searchCreditNote,
    };
    this.props.CreditNoteSearchSelectedPage(Sdata);
  };

  SearchOnChange = (event) => {
    let CreditNote = event.target.value;
    this.setState({
      searchShow: true,
      FilterTable: false,
      filterValue: "All",
      searchCreditNote: CreditNote,
    });
    let Sdatas = {
      Spage: this.state.Spage + 1,
      CreditNote: CreditNote,
    };
    this.props.CreditNoteSearch(Sdatas);
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.CreditNoteslsCount && this.props.CreditNoteslsCount;
    let CreditNotesPageCount = Math.ceil(count / this.state.perPage);

    let p2 = this.state.Spage + 1;
    const SearchCount =
      this.props.CreditNotesSearchCount && this.props.CreditNotesSearchCount;
    const SearchPageCount = Math.ceil(SearchCount / this.state.perPageS);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Credit Notes</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Search by Credit Number"
                      value={this.state.searchCreditNote}
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count === undefined && SearchCount === undefined ? (
                      0
                    ) : (
                      <span>
                        {!this.state.searchShow && count}
                        {this.state.searchShow && SearchCount}
                      </span>
                    )}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              {!this.state.searchShow && !this.state.FilterTable && (
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th>SL NO</th>
                      <th style={{ width: "200px" }}>Credit Number</th>
                      <th>Chemist </th>
                      <th>Distributor</th>
                      <th>CREATED DATE</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.CreditNotesDtlsList &&
                      this.props.CreditNotesDtlsList.map((item, i) => (
                        <tr key={i}>
                          <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.crdtRefNo}
                          </td>
                          <td className="cmn_Cap">
                            {/* {item !== null &&
                              item.crdtTo !== null &&
                              item.crdtTo.name} */}
                            {item !== null &&
                              item.chmstDtls !== null &&
                              item.chmstDtls.name}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                              item.dstbtrDtls !== null &&
                              item.dstbtrDtls.name}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, "dd-mmm-yyyy")
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.status}
                          </td>

                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleCreditNotesView({ item: item })
                                }
                              ></i>
                              <CreditNotesView
                                show={this.state.CreditNotesShow}
                                handleClose={this.handleCloseCreditNotesView}
                                CreditNotesDtls={this.state.CreditNotesDtls}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {this.state.searchShow && !this.state.FilterTable && (
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th>SL NO</th>
                      <th style={{ width: "200px" }}>Credit Number</th>
                      <th>Chemist </th>
                      <th>Distributor</th>
                      <th>CREATED DATE</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.CreditNotesSearchList &&
                      this.props.CreditNotesSearchList.map((item, i) => (
                        <tr key={i}>
                          <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.crdtRefNo}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                              item.chmstDtls !== null &&
                              item.chmstDtls.name}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                              item.dstbtrDtls !== null &&
                              item.dstbtrDtls.name}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.createdAt
                              ? dateFormat(
                                  item.createdAt,
                                  "dd-mmm-yyyy, h:MM TT"
                                )
                              : null}
                          </td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.status}
                          </td>

                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleCreditNotesView({ item: item })
                                }
                              ></i>
                              <CreditNotesView
                                show={this.state.CreditNotesShow}
                                handleClose={this.handleCloseCreditNotesView}
                                CreditNotesDtls={this.state.CreditNotesDtls}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {!this.state.searchShow &&
                !this.state.FilterTable &&
                (this.props.CreditNotesDtlsList === undefined ||
                  (this.props.CreditNotesDtlsList &&
                    this.props.CreditNotesDtlsList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Credit Notes Found</div>
                  </div>
                )}

              {this.state.searchShow &&
                !this.state.FilterTable &&
                (this.props.CreditNotesSearchList === undefined ||
                  (this.props.CreditNotesSearchList &&
                    this.props.CreditNotesSearchList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Credit Notes Found</div>
                  </div>
                )}
            </div>
          </Card.Body>
          {!this.state.searchShow &&
          !this.state.FilterTable &&
          CreditNotesPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={CreditNotesPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}

          {!this.state.FilterTable &&
          this.state.searchShow &&
          SearchPageCount &&
          SearchPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.Spage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={SearchPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageSearchClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default CreditNotes;
